import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReproductionCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12.8081C15 14.465 13.6569 15.8081 12 15.8081C10.3431 15.8081 9 14.465 9 12.8081C9 11.1513 10.3431 9.80811 12 9.80811C13.6569 9.80811 15 11.1513 15 12.8081Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 5.80811C8.13401 5.80811 5 8.94211 5 12.8081C5 13.3604 4.55228 13.8081 4 13.8081C3.44772 13.8081 3 13.3604 3 12.8081C3 7.83754 7.02944 3.80811 12 3.80811C16.9706 3.80811 21 7.83754 21 12.8081C21 17.7787 16.9706 21.8081 12 21.8081C11.4477 21.8081 11 21.3604 11 20.8081C11 20.2558 11.4477 19.8081 12 19.8081C15.866 19.8081 19 16.6741 19 12.8081C19 8.94211 15.866 5.80811 12 5.80811Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.8999 16.7697C5.80446 16.897 5.75 17.0946 5.75 17.2966C5.75 17.7108 5.41421 18.0466 5 18.0466C4.58579 18.0466 4.25 17.7108 4.25 17.2966C4.25 16.8783 4.35346 16.3317 4.69977 15.8698C5.07231 15.373 5.66462 15.0581 6.4512 15.0581C7.4068 15.0581 8.24714 15.5379 8.59388 16.3637C8.94562 17.2013 8.69523 18.1609 7.96147 18.9305C7.59981 19.3098 7.41214 19.5281 7.30232 19.7182C7.21404 19.8711 7.1692 20.0182 7.1692 20.2735C7.1692 20.6877 6.83342 21.0235 6.4192 21.0235C6.00499 21.0235 5.6692 20.6877 5.6692 20.2735C5.6692 19.7845 5.7693 19.3734 6.00335 18.9681C6.21585 18.6001 6.52791 18.2603 6.87586 17.8953C7.30273 17.4476 7.27822 17.1048 7.21086 16.9444C7.13851 16.7721 6.9148 16.5581 6.4512 16.5581C6.10241 16.5581 5.96913 16.6774 5.8999 16.7697Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.36562 22.5889C7.36562 23.0554 6.94422 23.4336 6.42439 23.4336C5.90456 23.4336 5.48315 23.0554 5.48315 22.5889C5.48315 22.1223 5.90456 21.7441 6.42439 21.7441C6.94422 21.7441 7.36562 22.1223 7.36562 22.5889Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.08806 22.0698C5.97593 22.1705 5.86562 22.3518 5.86562 22.5889C5.86562 22.8259 5.97593 23.0073 6.08806 23.1079C6.1976 23.2062 6.32073 23.2441 6.42439 23.2441C6.52805 23.2441 6.65118 23.2062 6.76072 23.1079C6.87284 23.0073 6.98315 22.8259 6.98315 22.5889C6.98315 22.3518 6.87284 22.1705 6.76072 22.0698C6.65118 21.9715 6.52805 21.9336 6.42439 21.9336C6.32073 21.9336 6.1976 21.9715 6.08806 22.0698ZM6.42439 23.4336C6.94422 23.4336 7.36562 23.0554 7.36562 22.5889C7.36562 22.1223 6.94422 21.7441 6.42439 21.7441C5.90456 21.7441 5.48315 22.1223 5.48315 22.5889C5.48315 23.0554 5.90456 23.4336 6.42439 23.4336Z",
			fill: "currentColor"
		})
	]
});
export default SvgReproductionCheck;
